import React from 'react';
import { iSettings } from './AppSettingsContext';

export interface iApiEndpoint {
    url: string;
    loaderMessage: string;
    expiry_mins: number;
    type: string;
    isFeatureLoader: boolean;
    removeCacheEndpoints: string[];
    refreshCacheEndpoints: string[];
    errorMessage: string;
}

let ApiEndpointsContext: React.Context<iApiEndpoint[]>;

export class ApiEndpointsGetter {
    public async getApiEndpoints(_appSettings: iSettings): Promise<React.Context<iApiEndpoint[]>> {
        // For CommodityBook, we can create an empty endpoints context
        // or fetch endpoint files if they exist in the future
        // appSettings can be used in the future to fetch endpoint files
        const endpoints: iApiEndpoint[] = [];

        ApiEndpointsContext = React.createContext(endpoints);
        return ApiEndpointsContext;
    }
}

const getApiEndpointsContext = () => ApiEndpointsContext;
export default getApiEndpointsContext;
